export const MAX_ORDER_QUANTITY = 9999;

// A decimal/negative/exponent string must never become an unrelated quantity
// (for example the old digits-only parser changed "1.5" into 15).
export function normalizeOrderQuantity(value) {
  const text = String(value ?? "").trim();
  if (!/^\d+$/.test(text)) return 1;
  const number = Number(text);
  if (!Number.isSafeInteger(number)) return 1;
  return Math.max(1, Math.min(MAX_ORDER_QUANTITY, number));
}
